var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E5A240",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 20.5V26.5C28 28.71 26.21 30.5 24 30.5H16C13.79 30.5 12 28.71 12 26.5V20.5C12 19.95 12.45 19.5 13 19.5H14.97C15.52 19.5 15.97 19.95 15.97 20.5V23.64C15.97 24.38 16.38 25.06 17.03 25.41C17.32 25.57 17.64 25.65 17.97 25.65C18.35 25.65 18.73 25.54 19.06 25.32L20.01 24.7L20.89 25.29C21.5 25.7 22.28 25.75 22.93 25.4C23.59 25.05 24 24.38 24 23.63V20.5C24 19.95 24.45 19.5 25 19.5H27C27.55 19.5 28 19.95 28 20.5Z",
    fill: "#E5A240"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 15.5V16.5C29.5 17.6 28.97 18.5 27.5 18.5H12.5C10.97 18.5 10.5 17.6 10.5 16.5V15.5C10.5 14.4 10.97 13.5 12.5 13.5H27.5C28.97 13.5 29.5 14.4 29.5 15.5Z",
    fill: "#E5A240"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.64 13.5004H14.12C13.78 13.1304 13.79 12.5604 14.15 12.2004L15.57 10.7804C15.94 10.4104 16.55 10.4104 16.92 10.7804L19.64 13.5004Z",
    fill: "#E5A240"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.87 13.5004H20.35L23.07 10.7804C23.44 10.4104 24.05 10.4104 24.42 10.7804L25.84 12.2004C26.2 12.5604 26.21 13.1304 25.87 13.5004Z",
    fill: "#E5A240"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9699 19.5C22.5199 19.5 22.9699 19.95 22.9699 20.5V23.63C22.9699 24.43 22.0799 24.91 21.4199 24.46L20.5199 23.86C20.1899 23.64 19.7599 23.64 19.4199 23.86L18.4799 24.48C17.8199 24.92 16.9399 24.44 16.9399 23.65V20.5C16.9399 19.95 17.3899 19.5 17.9399 19.5H21.9699Z",
    fill: "#E5A240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.a789a80b26e156e7ce60d72d366af242.svg";
export { ForwardRef as ReactComponent };